import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PumpebrondeTankePage from './pages/PumpebrondeTankePage';
import ReparationPage from './pages/ReparationPage';
import OverdaekningPage from './pages/OverdaekningPage';
import SpecialopgaverPage from './pages/SpecialopgaverPage';
import ProductsPage from './pages/ProductsPage';
import GlasfiberContainerePage from './pages/GlasfiberContainerePage';
import IgloFancyPage from './pages/IgloFancyPage';
import BatteriboksePage from './pages/BatteriboksePage';
import SandSaltContainerePage from './pages/SandSaltContainerePage';
import InformationPage from './pages/InformationPage';
import ReferencerPage from './pages/ReferencerPage';
import ContactPage from './pages/ContactPage';
import TakPage from './pages/TakPage';
import HandelsbetingelserPage from './pages/HandelsbetingelserPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-neutral-50 text-slate-900 font-sans antialiased">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          {/* Forside */}
          <Route path="/" element={<HomePage />} />

          {/* RB Glasfiber / Om os */}
          <Route path="/rb-glasfiber" element={<AboutPage />} />
          <Route path="/rb-glasfiber/pumpebronde-amp-tanke" element={<PumpebrondeTankePage />} />
          <Route path="/rb-glasfiber/reparationer" element={<ReparationPage />} />
          <Route path="/rb-glasfiber/overdaekning" element={<OverdaekningPage />} />
          <Route path="/rb-glasfiber/specialopgaver" element={<SpecialopgaverPage />} />

          {/* Standard produkter */}
          <Route path="/produkter" element={<ProductsPage />} />
          <Route path="/produkter/glasfiber-containere" element={<GlasfiberContainerePage />} />
          <Route path="/produkter/iglo-amp-fancy" element={<IgloFancyPage />} />
          <Route path="/produkter/iglo-amp-fancy/fancy-185" element={<IgloFancyPage />} />
          <Route path="/produkter/iglo-amp-fancy/joca-igloer" element={<IgloFancyPage />} />
          <Route path="/produkter/iglo-amp-fancy/klaebemaerker" element={<IgloFancyPage />} />
          <Route path="/produkter/batteribokse" element={<BatteriboksePage />} />
          <Route path="/produkter/sand-salt-containere" element={<SandSaltContainerePage />} />

          {/* Information */}
          <Route path="/information" element={<InformationPage />} />
          <Route path="/information/ce-godkendelser" element={<InformationPage />} />
          <Route path="/information/samarbejdspartnere" element={<InformationPage />} />

          {/* Referencer */}
          <Route path="/referencer" element={<ReferencerPage />} />

          {/* Kontakt & Tak */}
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/tak" element={<TakPage />} />

          {/* Betingelser */}
          <Route path="/handelsbetingelser" element={<HandelsbetingelserPage />} />

          {/* Error pages */}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
